/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useEffect, useLayoutEffect, useRef } from 'react'
import { isEmpty } from 'lodash'
import { Modal } from 'antd-mobile'
import useRootStore from '@store/useRootStore'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
//img
// import attendanceBanner from '@assets/images/banner/attendance-bottom-img.jpg'
import noticeCharacter from '@assets/images/bg/character/notice-character.png'
import attendanceDiaImg from '@assets/images/icon/money_icon/dia-01.png'
import attendanceTodayTxt from '@assets/images/text/attendance-today-txt.png'
import attendanceBtnBg from '@assets/images/bg/attendance-reward-btn-bg.png'
// css
import { ModalBg } from '@styles/base.style'
import { AdvDialogBtnWrap, AdvDialogStyle } from '@styles/modal'
import { Button } from '@styles/button.style'
import { ATTENADNCE_TYPE } from '@interface/common'
import { showToast, TOAST_TYPE } from '@utils/utils'
import { AttendanceWrap } from './index.style'
import { REWARD_COMPLETE_POPUP_TYPE } from '@views/Popup/Event/RewardComplete'
// icon
import { DiaIco } from '@shared/Icon/MoneyIcon'
import { AttendanceCheckIco } from '@shared/Icon/EtcIcon'
import { ComponentStore } from '@store/componentStore'
import dayjs from 'dayjs'
import DialogUtils from '@utils/dialog-utils'

// Modal
function closest(el, selector) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector
  let resultEl = el
  while (resultEl) {
    if (matchesSelector.call(resultEl, selector)) {
      return resultEl
    }
    resultEl = resultEl.parentElement
  }
  return null
}

export async function isShowAttendancePopup(componentStore: ComponentStore, certification) {
  if (!certification) {
    return false
  }

  await componentStore.getAttendance()

  if (!componentStore.attendance || !componentStore.attendance.id) {
    return false
  }

  const { startAt, reward, round, activeIndex, type: attendanceType } = componentStore.attendance

  if (reward.value) {
    const { lastHitAt } = reward.value
    if (!startAt
      || activeIndex > round
      || dayjs(lastHitAt).format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD')) {
      return false
    }
  }

  if (attendanceType === ATTENADNCE_TYPE.NEWBIE
    && dayjs(startAt).toDate() > dayjs(certification.createdAt).toDate()) {
    return false
  }

  return true
}

// const prefix = 'https://d1i7hydgfclv7m.cloudfront.net/data_center/item_image/'
const Attendance: React.FC = props => {
  const { authStore, globalStore, componentStore } = useRootStore()
  const { visibleAttendance } = globalStore
  const { attendance } = componentStore
  const { signedin, certificationInfo } = authStore

  const fetchAttendance = async () => {
    await componentStore.getAttendance()
  }

  const onCloseModal = () => {
    globalStore.setVisibleAttendance(false)
  }

  const onWrapTouchStart = e => {
    // fix touch to scroll background page on iOS
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return
    }
    const pNode = closest(e.target, '.am-modal-content')
    if (!pNode) {
      e.preventDefault()
    }
  }

  const initialize = async () => {
    if (signedin && visibleAttendance) {
      await fetchAttendance()
      if (componentStore.attendance && !componentStore.attendance.id) {
        onCloseModal()
        showToast(TOAST_TYPE.INFO, '출석 이벤트가 진행중이 아닙니다.')
      }
    }
    if (signedin && !attendance) {
      const isShow = await isShowAttendancePopup(componentStore, authStore.certificationInfo)
      if (isShow) {
        globalStore.setVisibleAttendance(true)
      }
    }
  }

  useEffect(() => {
    initialize()
  }, [visibleAttendance])

  const itemRefs = useRef([])

  useLayoutEffect(() => {
    if (!visibleAttendance) return

    const el = itemRefs.current[attendance?.activeIndex]
    if (!el) return

    el.scrollIntoView({ block: 'center' })
  }, [visibleAttendance, attendance?.activeIndex])

  // AdvDialog class
  const modalClassName = ['adv-new-dialog box-type']
  if (isMobile) {
    modalClassName.push('adv-new-dialog box-type big-size')
  } else {
    modalClassName.push('adv-new-dialog box-type big-size pc')
  }

  const onClickGetRewardNewbie = async () => {
    const reward = await componentStore.receiveAttendance({ id: attendance.id })
    await fetchAttendance()
    if (reward.item) {
      DialogUtils.showRewardCompletePopup(
        reward.item,
        REWARD_COMPLETE_POPUP_TYPE.ATTENDANCE,
        {
          wrapClassName: 'attendance-event-complete',
        }
      )
    } else {
      onCloseModal()
      showToast(TOAST_TYPE.INFO, '오늘 출석 이벤트는 이미 참여 하셨습니다.')
    }
  }

  const onClickGetRewardCommon = async () => {
    const reward = await componentStore.receiveAttendance({ id: attendance.id })
    await fetchAttendance()
    if (reward.item) {
      DialogUtils.showRewardCompletePopup(
        reward.item,
        REWARD_COMPLETE_POPUP_TYPE.ATTENDANCE,
        {
          wrapClassName: 'attendance-event-complete',
        }
      )
    } else {
      onCloseModal()
      showToast(TOAST_TYPE.INFO, '오늘 출석 이벤트는 이미 참여 하셨습니다.')
    }
  }

  const getEventDate = () => {
    const str = []
    const { startAt, endAt } = attendance
    if (attendance) {
      if (startAt && endAt) {
        str.push(dayjs(startAt).format('MM월 DD일'))
        str.push(' ~ ')
        str.push(dayjs(endAt).format('MM월 DD일'))
      } else {
        str.push('')
      }
    } else {
      str.push('')
    }
    return str.join('')
  }

  let modalElem = null
  let attendanceElem = null
  // const bottomBannerElem = (
  //   <div className="attendance-banner">
  //     <img src={attendanceBanner} alt="승부사온라인 ROAD FC 파트너쉽 체결 승부사온라인은 ROAD FC를 응원합니다." className="attendance-banner--img"/>
  //   </div>
  // )
  if (attendance && attendance.id && certificationInfo) {
    const { type: attendanceType, reward, startAt, activeIndex } = attendance

    if (attendanceType === ATTENADNCE_TYPE.NEWBIE
      && dayjs(startAt).toDate() <= dayjs(certificationInfo.createdAt).toDate()) {
      attendanceElem = (
        <AttendanceWrap>
          <h3 className="event-tit">{attendance.title}</h3>
          <div className="event-period">기간: {getEventDate()}</div>
          <span className="event-notice">&#8727; 출석체크는 동일 명의 당 1회만 가능합니다.</span>
          <ul className="attendance-list">
            {attendance && attendance.data.map((attendanceUnit, index) =>
              <li
                className="attendance-list--item"
                key={`Attendance:List:Item${attendanceUnit.index}`}
                ref={el => (itemRefs.current[attendanceUnit.index] = el)}
              >
                <Button
                  // 보상 받기 가능: 'reward-btn active'
                  // 보상 받기 불가능: 'reward-btn'
                  className={activeIndex === attendanceUnit.index ? 'reward-btn active' : 'reward-btn'}
                  onClick={activeIndex === attendanceUnit.index ? onClickGetRewardNewbie : null}
                >
                  <span className="reward-btn--day">
                    {/*{attendanceUnit.index + 1 === 7 && <img src={starImg} alt="7일차 별" className='last-reward-img'/>}*/}
                    {attendanceUnit.index + 1}일차
                    {/*{attendanceUnit.index + 1 === 7 && <img src={starImg} alt="7일차 별" className='last-reward-img'/>}*/}
                  </span>

                  {/*<div className="reward-btn--ico">*/}
                  {/*  <span className="attendance-pulse-ani"/>*/}
                  {/*  <span className="attendance-pulse-ani ani-2"/>*/}
                  {/*  <span className="attendance-pulse-ani ani-3"/>*/}
                  {/*  <img src={`${prefix}${attendanceUnit.icon}.png`} alt="출석 보상" width="30px" height="30px"/>*/}
                  {/*</div>*/}
                  <img src={attendanceDiaImg} alt="출석 보상" className="reward-btn--ico"/>

                  {attendanceUnit.volume > 0 && <span className="reward-btn--num">{attendanceUnit.volume}</span>}
                  {attendanceUnit.quantity > 0 && <span className="reward-btn--num">{attendanceUnit.quantity}</span>}
                  {attendanceUnit.period > 0 && <span className="reward-btn--num">{attendanceUnit.period}</span>}
                  <div className="reward-btn--txt">{(!isEmpty(reward) && attendanceUnit.index + 1 <= reward.value.hitCount) ? '수령완료' : '보상받기'}</div>
                </Button>

                {/* ******** 보상 받은 후 ******** */}
                {(!isEmpty(reward) && attendanceUnit.index + 1 <= reward.value.hitCount) &&
                  <div className="reward-complete">
                    <span className="check-ico"/>
                    {/*<img src={completeIco} alt="출석 보상 완료" className="reward-complete--img"/>*/}
                  </div>
                }
              </li>,
            )}
          </ul>
          {/* 하단 배너 */}
          {/*{bottomBannerElem}*/}
        </AttendanceWrap>
      )
    } else if (attendanceType === ATTENADNCE_TYPE.COMMON) {
      /** 일반출석체크 출석 회차 7일 스타일 별도 지정 (신규출석체크 동일 스타일) */
      const commonSevenAttendance = attendance.data.length === 7

      attendanceElem = (
        <AttendanceWrap>
          <h3 className="event-tit">{attendance.title}</h3>
          <div className="event-period">기간: {getEventDate()}</div>
          <span className="event-notice">&#8727; 출석체크는 동일 명의 당 1회만 가능합니다.</span>
          <ul className={commonSevenAttendance ? 'attendance-list' : 'attendance-list common'}>
            {attendance && attendance.data.map((attendanceUnit, index) => {
                const isTodayAttendance = activeIndex === attendanceUnit.index
                  || (attendanceUnit.index + 1 == reward?.value?.hitCount
                    && dayjs(reward?.value.lastHitAt).format('YYYY-MM-dd') === dayjs().format('YYYY-MM-dd'))

                let attendanceBtn
                if (commonSevenAttendance) {
                  attendanceBtn = (
                    <Button
                      // 보상 받기 가능: 'reward-btn active'
                      // 보상 받기 불가능: 'reward-btn'
                      className={isTodayAttendance ? 'reward-btn active' : 'reward-btn'}
                      onClick={(activeIndex === attendanceUnit.index
                        || attendanceUnit.index + 1 <= reward?.value?.hitCount) ? onClickGetRewardCommon : null}
                    >
                  <span className="reward-btn--day">
                    {attendanceUnit.index + 1}일차
                  </span>

                      <img src={attendanceDiaImg} alt="출석 보상" className="reward-btn--ico"/>

                      {attendanceUnit.volume > 0 && <span className="reward-btn--num">{attendanceUnit.volume}</span>}
                      {attendanceUnit.quantity > 0 && <span className="reward-btn--num">{attendanceUnit.quantity}</span>}
                      {attendanceUnit.period > 0 && <span className="reward-btn--num">{attendanceUnit.period}</span>}
                      <div
                        className={(!isEmpty(reward) && attendanceUnit.index + 1 <= reward.value.hitCount)?'reward-btn--txt complete':'reward-btn--txt'}>{(!isEmpty(reward) && attendanceUnit.index + 1 <= reward.value.hitCount) ? '수령완료' : '보상받기'}</div>
                    </Button>
                  )
                } else {
                  attendanceBtn = (
                    <Button
                      // 보상 받기 가능: 'reward-btn active'
                      // 보상 받기 불가능: 'reward-btn'
                      className={isTodayAttendance ? 'reward-btn active' : 'reward-btn'}
                      onClick={(activeIndex === attendanceUnit.index
                        || attendanceUnit.index + 1 <= reward?.value?.hitCount) ? onClickGetRewardCommon : null}
                    >
                      {isTodayAttendance
                        && <img className="today-txt" src={attendanceTodayTxt} alt="오늘 받을 보상"/>}
                      <span className="reward-btn--day">
                            {attendanceUnit.index + 1}
                        </span>
                      <div
                        className={(attendanceUnit.index + 1 <= reward?.value?.hitCount ? 'reward-btn--ico gray' : 'reward-btn--ico')}>
                        <DiaIco/>
                      </div>

                      {attendanceUnit.volume > 0 &&
                        <span
                          className={(!isEmpty(reward) && attendanceUnit.index + 1 <= reward.value?.hitCount ? 'reward-btn--num gray' : 'reward-btn--num')}>
                            {attendanceUnit.volume.toLocaleString()}
                          </span>
                      }
                      {attendanceUnit.index % 5 === 4 &&
                        <img className="reward-btn--bg" src={attendanceBtnBg} alt=""/>
                      }
                    </Button>
                  )
                }

                return (
                  <li className="attendance-list--item" key={`Attendance:List:Item${index}`}>
                    {attendanceBtn}
                    {/* ******** 보상 받은 후 ******** */}
                    {(!isEmpty(reward) && attendanceUnit.index + 1 <= reward.value.hitCount) &&
                      <div className="reward-complete">
                        {commonSevenAttendance ? <span className="check-ico"/> : <AttendanceCheckIco/>}
                      </div>
                    }
                  </li>
                )
              },
            )}
          </ul>
        </AttendanceWrap>
      )
    } else {
      attendanceElem = (
        <AttendanceWrap className="not-target">
          <div className="notice-wrap">
            <img src={noticeCharacter} alt="" className="notice-character"/>
            <div className="notice-txt-box">
              <span className="notice-txt-box--date">{getEventDate()}</span>
              <span className="notice-txt-box--txt">이벤트 기간 내에 신규 가입자만 참여 가능합니다.<br/>(중복 가입 제외)</span>
            </div>
          </div>
        </AttendanceWrap>
      )
    }

    modalElem = (
      <Modal
        transparent
        visible={visibleAttendance}
        maskClosable={false}
        wrapProps={{ onTouchStart: onWrapTouchStart }}
        onClose={onCloseModal}
        // title={attendance.title}
        wrapClassName="attendance-event"
        className={modalClassName.join(' ')}
        css={AdvDialogStyle}
      >
        {attendanceElem}
        <AdvDialogBtnWrap className="adv-dialog-btn-wrap">
          <Button secondary onClick={onCloseModal} className="single-btn">
            확인
          </Button>
        </AdvDialogBtnWrap>
        <ModalBg className="dialog-bg" onClick={onCloseModal}/>
      </Modal>
    )
  }

  return (
    <Fragment>
      {modalElem}
    </Fragment>
  )
}

export default observer(Attendance)
